module.exports = __webpack_public_path__ + "img/运维服务集成@2x.b9cc8566.png";